<div class="form-group row">
  <div class="col-md-1">
    <button [disabled]="isProcessDisabled" class="btn btn-primary btn-lg" (click)="onProcessClick()" type="button">Process {{buttonText}}</button>
  </div>
  <div class="col-md-9"></div>
</div>
